import { currentCountry } from '@rcg/ui-react';
import RCCL_UUID from '@rcg/uuid';

const LD_SESSION_STORAGE_KEY = 'ldFlags';

const SHOW_EDIT_GUEST_INFO_CTA = 'show-edit-guest-info-cta';
const VIEW_EDIT_GUEST_INFO_CTA = 'show-view-guest-info-cta';
const ENABLE_3DS_PAYMENT_GATEWAY = 'enable-3ds-payment-gateway';
const ENABLE_NEW_PAYMENT_LAYOUT = 'enable-new-payment-layout';
const ENABLE_GIFT_CARDS_PAYMENT = 'enable-gift-cards-payment';
const ENABLE_GIFT_CARD_TOKENIZATION = 'enable-gift-card-tokenization';
const ENABLE_CRUISE_BOOKING_TYPES = 'enable-cruise-booking-types';
const ENABLE_AFFIRM_TOKENIZATION = 'enable-affirm-tokenization';
const ENABLE_AFFIRM_PAYMENT = 'enable-affirm-payment';
const ENABLE_BUNDLED_TAXES_AND_FEES = 'enable-bundled-taxes-and-fees';
const ENABLE_CVV_COLLECTION = 'enable-cvv-collection';
const ENABLE_TRAVEL_DOCUMENT_FIELD = 'enable-travel-document-field';

const key = (country) => {
  return `${LD_SESSION_STORAGE_KEY}_${country}`;
};

const LDUser = () => {
  let user = RCCL_UUID.getRWDId();
  if (!user) {
    RCCL_UUID.createRWDId();
    user = RCCL_UUID.getRWDId();
  }
  return user;
};

const hasLDFlags = () => !!sessionStorage.getItem(key(currentCountry()));

const setLDFlags = (flags) => {
  const country = currentCountry();
  Object.entries(sessionStorage).forEach(([ssKey]) => {
    if (key(country) !== ssKey && ssKey.startsWith(LD_SESSION_STORAGE_KEY)) {
      sessionStorage.removeItem(ssKey);
    }
  });
  if (flags?.ldFlags) {
    sessionStorage.setItem(key(country), JSON.stringify(flags.ldFlags));
  }
};

const getLDFlag = (ldFlagName) => {
  const ldFlags = sessionStorage.getItem(key(currentCountry()));
  const flags = ldFlags && JSON.parse(ldFlags);
  return flags?.[ldFlagName];
};

export {
  getLDFlag,
  hasLDFlags,
  setLDFlags,
  LDUser,
  SHOW_EDIT_GUEST_INFO_CTA,
  VIEW_EDIT_GUEST_INFO_CTA,
  ENABLE_3DS_PAYMENT_GATEWAY,
  ENABLE_NEW_PAYMENT_LAYOUT,
  ENABLE_GIFT_CARDS_PAYMENT,
  ENABLE_GIFT_CARD_TOKENIZATION,
  ENABLE_CRUISE_BOOKING_TYPES,
  ENABLE_AFFIRM_TOKENIZATION,
  ENABLE_AFFIRM_PAYMENT,
  ENABLE_BUNDLED_TAXES_AND_FEES,
  ENABLE_CVV_COLLECTION,
  ENABLE_TRAVEL_DOCUMENT_FIELD,
};
